// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

export const API_ENDPOINTS = {
  // Auth endpoints
  login: `${API_BASE_URL}/api/auth/login`,
  verify: `${API_BASE_URL}/api/auth/verify`,
  changePassword: `${API_BASE_URL}/api/auth/change-password`,

  // Contact endpoint
  contact: `${API_BASE_URL}/api/contact/send`,

  // Future admin endpoints
  // products: `${API_BASE_URL}/api/products`,
  // services: `${API_BASE_URL}/api/services`,
  // pages: `${API_BASE_URL}/api/pages`,
};

export default API_BASE_URL;

